import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { Main } from 'Containers';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { ManageTruckRouteScheduleListEnum } from 'Common/FieldEnum';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { HeaderLeftAlign } from 'Common/Constants/table';

import { BASE_URL } from './../../helper';
import ManageTruckRouteScheduleList from '../../components/managetruckrouteschedulelist/ManageTruckRouteScheduleList';
import * as ManageTruckRouteScheduleListSelectors from '../../state/managetruckrouteschedulelist/selectors';
import {
  getRouteSchedule,
  deleteTruckRouteSchedule,
  clearDeleteTruckRouteScheduleSuccess,
  clearTruckRouteErrors,
} from '../../state/managetruckrouteschedulelist/actions';

class ManageTruckRoutesScheduleListContainer extends Component {
  static propTypes = {
    truckRouteScheduleListData: PropTypes.array,
    truckRouteScheduleDataLoading: PropTypes.bool,
    truckRouteScheduleDataLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    deleteTruckRouteScheduleSuccess: PropTypes.object,
    deleteTruckRouteScheduleLoading: PropTypes.bool,
    deleteTruckRouteScheduleError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    getRouteSchedule: PropTypes.func.isRequired,
    deleteTruckRouteSchedule: PropTypes.func.isRequired,
    clearDeleteTruckRouteScheduleSuccess: PropTypes.func.isRequired,
    clearTruckRouteErrors: PropTypes.func.isRequired,
  };

  static defaultProps = {
    truckRouteScheduleListData: [],
    truckRouteScheduleDataLoading: false,
    truckRouteScheduleDataLoadingError: null,
    deleteTruckRouteScheduleSuccess: null,
    deleteTruckRouteScheduleLoading: false,
    deleteTruckRouteScheduleError: null,
  };

  state = {
    showDeleteConfirm: false,
    selectedRouteSchedule: null,
  };
  reactTableWrapperInstance = React.createRef();

  columns = [
    {
      Header: () => <span className="ml-5">Description</span>,
      accessor: ManageTruckRouteScheduleListEnum.Description,
      ...HeaderLeftAlign,
      ...ReactTableWrapperColumnProperties,
    },
    {
      resizable: false,
      width: 50,
      sortable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.getMenuOptions(gridProps),
        });
      },
    },
  ];

  componentDidMount() {
    this.props.getRouteSchedule();
  }

  componentDidUpdate(prevProps) {
    const {
      clearTruckRouteErrors,
      deleteTruckRouteScheduleSuccess,
      clearDeleteTruckRouteScheduleSuccess,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'truckRouteScheduleDataLoadingError') ||
      errorToast(this.props, prevProps, 'deleteTruckRouteScheduleError')
    ) {
      clearTruckRouteErrors();
    }
    if (
      deleteTruckRouteScheduleSuccess &&
      deleteTruckRouteScheduleSuccess !== prevProps.deleteTruckRouteSuccess
    ) {
      createToast(
        toastType.success,
        'Success',
        deleteTruckRouteScheduleSuccess.Data,
        true
      );
      clearDeleteTruckRouteScheduleSuccess();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMenuOptions = gridProps => {
    const { row } = gridProps;
    return [
      {
        icon: 'pencil',
        text: 'View/Edit',
        handler: () => this.onEditClick(row),
      },
      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        handler: () => this.onDeleteClick(row),
      },
    ];
  };

  onEditClick = gridProps => {
    const { _original } = gridProps;
    this.props.history.push(
      `${BASE_URL}/schedule/1/${_original[ManageTruckRouteScheduleListEnum.Id]}`
    );
  };

  onDeleteClick = row => {
    const { _original } = row;
    this.setState({
      selectedRouteSchedule: _original,
      showDeleteConfirm: true,
    });
  };

  handleDeleteDialog = result => {
    if (result) {
      this.props.deleteTruckRouteSchedule(
        this.state.selectedRouteSchedule[ManageTruckRouteScheduleListEnum.Id]
      );
    }
    this.setState({ showDeleteConfirm: false });
  };

  clearFilters = () => {
    this.reactTableWrapperInstance &&
      this.reactTableWrapperInstance.clearTableState();
  };

  setReactTableWrapperInstance = ref => {
    this.reactTableWrapperInstance = ref;
  };

  render() {
    return (
      <Fragment>
        <Main shouldNotUsePageWidth>
          <ManageTruckRouteScheduleList
            getMenuOptions={this.getMenuOptions}
            clearFilters={this.clearFilters}
            columns={this.columns}
            showDeleteConfirm={this.state.showDeleteConfirm}
            selectedRouteSchedule={this.state.selectedRouteSchedule}
            handleDeleteDialog={this.handleDeleteDialog}
            setReactTableWrapperInstance={this.setReactTableWrapperInstance}
            routeScheduleData={this.props.truckRouteScheduleListData}
            truckRouteScheduleDataLoading={
              this.props.truckRouteScheduleDataLoading
            }
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty()(state));
  return {
    truckRouteScheduleListData: ManageTruckRouteScheduleListSelectors.getTruckRouteScheduleList(
      state
    ),
    truckRouteScheduleDataLoading: ManageTruckRouteScheduleListSelectors.getTruckRouteScheduleDataLoading(
      state
    ),
    truckRouteScheduleDataLoadingError: ManageTruckRouteScheduleListSelectors.getTruckRouteScheduleDataLoadingError(
      state
    ),
    deleteTruckRouteScheduleSuccess: ManageTruckRouteScheduleListSelectors.getDeleteTruckRouteScheduleSuccess(
      state
    ),
    deleteTruckRouteScheduleLoading: ManageTruckRouteScheduleListSelectors.getDeleteTruckRouteScheduleLoading(
      state
    ),
    deleteTruckRouteScheduleError: ManageTruckRouteScheduleListSelectors.getDeleteTruckRouteScheduleError(
      state
    ),
  };
};

const mapDispatchToProps = {
  getRouteSchedule,
  deleteTruckRouteSchedule,
  clearDeleteTruckRouteScheduleSuccess,
  clearTruckRouteErrors,
};

export const Truckrouteschedule = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageTruckRoutesScheduleListContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/managetruckrouteschedulelist/ManageTruckRouteScheduleList.js